import * as THREE from "three";

/** `THREE.Matrix4.elements` is a Float32Array — not `Array.isArray`. JSON uses plain number[]. */
function hasAtLeast16Elements(v) {
  return v != null && typeof v.length === "number" && v.length >= 16;
}

/**
 * Plain `{ elements }` from JSON, THREE.Matrix4 from the editor, or missing.
 * Skips `.copy` when `elements` is missing (avoids JSON `isMatrix4` ghosts without data).
 */
export function matrix4FromState(matrixState) {
  const m = new THREE.Matrix4();
  if (matrixState == null) return m.identity();
  if (matrixState.isMatrix4) {
    const me = matrixState.elements;
    if (hasAtLeast16Elements(me)) return m.copy(matrixState);
    return m.identity();
  }
  const src = Array.isArray(matrixState) ? matrixState : matrixState?.elements;
  if (hasAtLeast16Elements(src)) return m.fromArray(src);
  return m.identity();
}
